import React, { forwardRef, useEffect, useRef, Suspense, useMemo, useState } from "react";
import { Canvas, extend, useThree, useLoader, useFrame, } from '@react-three/fiber'
import { FontLoader } from 'three/examples/jsm/loaders/FontLoader'
import { TextGeometry } from 'three/examples/jsm/geometries/TextGeometry'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls'
import { Center, Float, Text3D, GradientTexture, useTexture } from "@react-three/drei";
import { getRandomIntNumberWithSymbol, getRandomNumber } from "../../../../functions/GeneralHelper";
import { useStore } from "../../store";
import * as THREE from 'three'
import { useSprings, animated } from "@react-spring/three";
import _ from "lodash";
import { useDrag } from '@use-gesture/react'
extend({ TextGeometry, OrbitControls })


const cards = [
    'https://bqltest.s3.ap-southeast-1.amazonaws.com/bqlPortfolio/project/idd/Idd6.PNG',
    'https://bqltest.s3.ap-southeast-1.amazonaws.com/bqlPortfolio/project/idd/Idd5.PNG',
    'https://bqltest.s3.ap-southeast-1.amazonaws.com/bqlPortfolio/project/idd/Idd4.PNG',
    'https://bqltest.s3.ap-southeast-1.amazonaws.com/bqlPortfolio/project/idd/Idd3.PNG',
    'https://bqltest.s3.ap-southeast-1.amazonaws.com/bqlPortfolio/project/idd/Idd2.PNG',
    'https://bqltest.s3.ap-southeast-1.amazonaws.com/bqlPortfolio/project/idd/Idd1.PNG',
    'https://bqltest.s3.ap-southeast-1.amazonaws.com/bqlPortfolio/project/idd/Idd0.PNG',
]
const to = (i) => ({
    x: 0,
    y:THREE.MathUtils.degToRad(getRandomIntNumberWithSymbol(0, 10)),
    scale: 1,
    rot: -10 + Math.random() * 20,
    delay: i * 100,
    transform: i
})
const from = (_i) => ({ x: 0, rot: 0, scale: 1.5, y: -1000 })
// This is being used down there in the view, it interpolates rotation and scale into a css transform
const trans = (r, s) => {
    console.log(`perspective(1500px) rotateX(30deg) rotateY(${r / 10}deg) rotateZ(${r}deg) scale(${s})`)
    return `perspective(1500px) rotateX(30deg) rotateY(${r / 10}deg) rotateZ(${r}deg) scale(${s})`
}


const ObjectCard = forwardRef(({ children, position, url, size, ...props }, ref) => {
    const [gone] = useState(() => new Set()) // The set flags all the cards that are flicked out
    const [items, api] = useSprings(cards.length, i => {
        let temp = {
            to: to(i),
            from: from(i),
        }
        return (temp)
    })

    const textures = useTexture(cards)
    const floatIntensity = useMemo(() => getRandomNumber(2, 6), [])
    const speed = useMemo(() => getRandomNumber(0.1, 4), [])
    const { setObjectSelected, objectSelected, setIsDragging, isDragging } = useStore()

    useEffect(() => {
        if (textures.length !== 0) {
            da()
        }
    }, [textures])
    function da() {
        let temp = []
        _.forEach(cards, (v, i) => {
            temp.push({
                to: to(i),
                from: from(i),
                texture: textures[i]
            })
        })
        console.log(temp)
        api(temp)
    }
    const bind = useDrag(({ args: [index], active, movement: [mx], direction: [xDir], velocity: [vx] }) => {
        const trigger = vx > 0.2 // If you flick hard enough it should trigger the card to fly out
        if (!active && trigger) gone.add(index) // If button/finger's up and trigger velocity is reached, we flag the card ready to fly out
        // setIsDragging(true)
        api.start(i => {
            if (index !== i) return // We're only interested in changing spring-data for the current spring
            const isGone = gone.has(index)
            const x = isGone ? (200 + window.innerWidth) * xDir : active ? mx : 0 // When a card is gone it flys out left or right, otherwise goes back to zero
            const rot = mx / 100 + (isGone ? xDir * 10 * vx : 0) // How much the card tilts, flicking it harder makes it rotate faster
            const scale = active ? 1.1 : 1 // Active cards lift up a bit
            return {
                x,
                rot,
                scale,
                delay: undefined,
                config: { friction: 50, tension: active ? 800 : isGone ? 200 : 500 },
                onRest: () => {
                    setIsDragging(false)
                }
            }

        })
        if (!active && gone.size === cards.length)
            setTimeout(() => {
                gone.clear()
                api.start(i => to(i))
            }, 600)
    })
    return (
        <group  >
            {items.map((v, k) =>
                <animated.mesh
                    position={[0, 0, (k / 100 + 2)]}
                    rotation={[THREE.MathUtils.degToRad(-15), 0, v.y, 'XYZ']}
                >
                    <planeBufferGeometry args={[3.1, 1.6]} />
                    <meshBasicMaterial color={'gray'} side={THREE.DoubleSide} />

                    <animated.mesh
                        //   ref={ref}
                        position={[0, 0, 0.01 ]}
                        // rotation={[THREE.MathUtils.degToRad(-30), 0, THREE.MathUtils.degToRad(10), 'XYZ']}
                        {...bind(v)}
                    >
                        <planeBufferGeometry args={[3, 1.5]} />
                        <meshBasicMaterial map={textures[k] ? textures[k] : null} opacity={1} transparent side={THREE.DoubleSide} />
                    </animated.mesh>

                </animated.mesh>


            )}
        </group>


    )
})

export default ObjectCard